import React, { useState } from 'react';
import { palacioStorePhotos } from '../../data/palacioImages';

/**
 * In-store immersion photos. A photo that the browser can't display (e.g. HEIC outside Safari)
 * is dropped instead of leaving a broken tile; if none load, the strip disappears.
 */
export function StorePhotos() {
  const [failed, setFailed] = useState<string[]>([]);
  const photos = palacioStorePhotos.filter(p => !failed.includes(p.src));
  if (photos.length === 0) return null;
  return <ul className="grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-666" data-mp="25k4kbs75tvdv">
      {photos.map(photo => <li key={photo.src} className="overflow-hidden rounded-2xl bg-surface" data-id="element-667" data-mp="2jjntmobpjcrr">
          <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" onError={() => setFailed(prev => [...prev, photo.src])} className="aspect-[3/4] h-full w-full object-cover" data-id="element-668" data-mp="2jhjhxk7kh9gx" />
        </li>)}
    </ul>;
}